/**
 * editor-button.js
 */

import React from 'react';
import Button from "components/button";
import Icon from 'components/icon';
import {
  useMediaQuery,
  IconButton,
  Tooltip
} from '@mui/material';
import { Link } from "react-router-dom";


function ContainedEditButton(props) {
  return (
    <Button
      variant='contained'
      children={props.children || 'Edit'}
      startIcon={<Icon type='edit' />}
      {...props}
    />
  );
}


function IconEditButton(props) {
  return (
    <IconButton
      style={props.disabled ? {} : { color: 'inherit' }}
      {...props}
      size="large">
      <Icon type='edit' />
    </IconButton>
  );
}


function ContainedIconEditButton(props) {
  const { sx, ...rest } = props;

  return (
    <Button
      variant='contained'
      {...rest}
      sx={{ 
        padding: 0.5,
        minWidth: 'auto',
        borderRadius: '50%',
        ...sx,
       }}
    >
      <Icon type='edit' />
    </Button>
  );
}


export default function EditButton(props) {
  const {
    tooltip,
    iconOnly,
    minBreakpoint,
    contained,
    ...rest
  } = props;
  const buttonProps = {...rest};
  const hideForMobile = useMediaQuery(theme => theme.breakpoints.down(minBreakpoint), { noSsr: true });

  if (hideForMobile) {
    return null;
  }

  if ('to' in buttonProps && !('component' in buttonProps)) {
    buttonProps['component'] = Link;
  }
  const button = <>
    {iconOnly
      ? contained
        ? <ContainedIconEditButton {...buttonProps} />
        : <IconEditButton {...buttonProps} />
      : <ContainedEditButton {...buttonProps} />
    }
  </>

  if (tooltip) {
    return (
      <Tooltip
        arrow
        title={tooltip}
      >
        <span>{button}</span>
      </Tooltip>
    );
  } else {
    return button;
  }
}